import React, { useEffect, useState } from 'react'
import { signInSilentCallback } from '../services/auth.service'

const SignInSilentCallback = () => {
  const [error, setError] = useState(false)

  useEffect(() => {
    const handleSilentCallback = async () => {
      try {
        await signInSilentCallback()
      } catch (err) {
        console.warn('Silent renew callback error', err)
        setError(true)
      }
    }

    handleSilentCallback()
  }, [])

  if (error) {
    return (
      <div>
        <p>Silent login failed. Please refresh or login manually.</p>
      </div>
    )
  }

  return <div>Renewing token...</div>
}

export default SignInSilentCallback
